export default [
    {
        skillName: "React",
        level: "Proficient",
        logo: "https://ionicframework.com/docs/icons/logo-react-icon.png",
    },
    {
        skillName: "JavaScript",
        level: "Proficient",
        logo: "https://cdn.worldvectorlogo.com/logos/javascript-1.svg",
    },
    {
        skillName: "HTML | CSS",
        level: "Proficient",
        logo: "https://i.ibb.co/Y0fCkph/css-and-html.png",
    },
    {
        skillName: "UI | Figma",
        level: "Proficient",
        logo: "https://cdn.sanity.io/images/599r6htc/localized/46a76c802176eb17b04e12108de7e7e0f3736dc6-1024x1024.png?w=670&h=670&q=75&fit=max&auto=format",
    },
    {
        skillName: "Java",
        level: "Skilled",
        logo: "https://cdn-icons-png.flaticon.com/512/226/226777.png",
    },
    {
        skillName: "Photoshop",
        level: "Skilled",
        logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/640px-Adobe_Photoshop_CC_icon.svg.png",
    },
];
